import Vue from 'vue'

import {
  formatDateRelative,
  formatDateStandard,
  formatDateTimeSecondsStandard,
  formatDateTimeStandard,
} from '@/utilities/date-utilities'
import { humanFileSize } from '@/utilities/file-helper'

/*
 * Standardized date filters using the utility functions
 */

Vue.filter('formatDate', function (value) {
  return formatDateStandard(value)
})

Vue.filter('formatDateTime', function (value) {
  return formatDateTimeStandard(value)
})

Vue.filter('formatDateTimeSeconds', function (value) {
  return formatDateTimeSecondsStandard(value)
})

Vue.filter('formatDateShort', function (value) {
  return formatDateStandard(value)
})

Vue.filter('formatDateRelative', function (value) {
  return formatDateRelative(value)
})

Vue.filter('formatFileSize', function (value) {
  if (!value) return
  return humanFileSize(value)
})

Vue.filter('formatDecimal', function (value, digits) {
  if (isNaN(value)) return
  return parseFloat(value).toFixed(digits)
})

Vue.filter('notSupplied', function (value) {
  if (!value) return '(empty)'
  return value
})

Vue.filter('formatAlienNumber', function (value) {
  if (!value) return

  const str = value.toString().trim().padStart(9, '0')
  if (str.length !== 9) return value

  const parts = str.split(/([0-9]{3})/).filter(entry => !!entry)

  if (parts.length !== 3) return value

  return parts.join('-')
})
